<template>
  <vue-final-modal v-slot="{ close }">
    <div class="loginmodal alert-backdrop">
      <div class="art" :class="level" role="dialog" aria-modal="true">
        <span class="status-icon" aria-hidden="true">
          {{ level === 'warningart' ? '!' : type === 'confirm' ? '?' : 'i' }}
        </span>
        <p v-if="plainText" class="alert-message">{{ code }}</p>
        <p v-else class="alert-message" v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button class="yes" @click="$emit('confirm', 'yes', close)">{{$t('front.button.yes')}}</button>
            <button class="no" @click="$emit('confirm', 'no', close)">{{$t('front.button.no')}}</button>
          </template>

          <template v-if="type == 'check'">
            <button class="yes" @click="$emit('check', 'ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button class="closeart" type="button" aria-label="close" @click="onClose(close)">×</button>
      </div>
    </div>
  </vue-final-modal>

</template>

<script>

export default {
  name: 'Alert',
  props: {
    plainText: {
      type: Boolean,
      default: false
    },
    code: {
      type: String
    },
    type: {
      type: String
    },
    level: {
      type: String,
      default: 'warningart'
    }
  },
  data () {
    return {
      lang: 'ko',
      result: ''
    }
  },
  methods: {
    onClose (close) {
      close()
      // this.$emit('close', this.type, this.result)
    }
  }
}
</script>

<style scoped>
button {font: inherit;cursor: pointer;}
.loginmodal.alert-backdrop {display: flex;align-items: center;justify-content: center;padding: 24px;box-sizing: border-box;background: rgba(40, 35, 27, 0.3);}
.art {position: relative;box-sizing: border-box;width: min(400px, calc(100vw - 48px));margin: 0;padding: 32px 30px 26px;text-align: center;border: 1px solid #e5dccb;border-radius: 16px;box-shadow: 0 18px 50px rgba(57, 44, 23, 0.18);background: #fffdfa;color: #3c352b;}
.status-icon {display: flex;align-items: center;justify-content: center;width: 34px;height: 34px;margin: 0 auto 18px;border: 1px solid #d6c5a4;border-radius: 50%;background: #f6f0e5;color: #806238;font-size: 17px;font-weight: 700;line-height: 1;}
.warningart .status-icon {border-color: #d6c5a4;color: #806238;}
.art .alert-message {margin: 0;color: #3c352b;font-size: 15px;font-weight: 500;line-height: 1.65;word-break: keep-all;overflow-wrap: anywhere;}
.art .btn {display: flex;justify-content: center;gap: 8px;margin-top: 26px;}
.art .yes, .art .no {box-sizing: border-box;min-width: 112px;height: 40px;padding: 0 22px;border-radius: 7px;font-size: 14px;font-weight: 600;text-shadow: none;transition: border-color 0.15s ease, background-color 0.15s ease;}
.art .yes {border: 1px solid #c7b38d;background: #c7b38d;color: #352a1a;}
.art .yes:hover {border-color: #bda579;background: #bda579;}
.art .no {border: 1px solid #ddd3c2;background: #fffdfa;color: #665b48;}
.art .no:hover {border-color: #c7b38d;background: #f6f0e5;color: #3c352b;}
.closeart {position: absolute;right: 13px;top: 11px;width: 30px;height: 30px;padding: 0;border: 0;background: transparent;color: #817463;font-size: 24px;font-weight: 300;line-height: 28px;}
.closeart:hover {color: #3c352b;}
button:focus-visible {outline: 2px solid #806238;outline-offset: 3px;}
</style>
<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
